<template>
  <div class="data-import-container">
    <div class="header">
      <p class="title">数据导入</p>
      <div class="common-button-box import-btn">
        <el-button
          size="small"
          class="normal-btn"
          @click="openUploadList">
          <div class="btn-list">
            <icon-svg
              icon-class="ic-ico_upload"
              class="icon gr4" />
            上传列表
          </div>
        </el-button>
      </div>
    </div>
    <div class="operate-area-box">
      <div class="common-button-box btn-group-primary">
        <div
          class="common-dropdown-box gr8"
          v-if="isChecked('Data.Migration.Import.Import')">
          <el-dropdown
            placement="bottom"
            @visible-change="handleVisibleChange"
            @command="importData"
            trigger="click">
            <el-button
              type="primary"
              class="primary-btn"
              size="small"
              >本地导入</el-button
            >
            <el-dropdown-menu
              slot="dropdown"
              class="dropdown-primary">
              <el-dropdown-item
                :command="2"
                class="upload-dropdown-item-box">
                <el-button
                  type="text"
                  size="small"
                  class="upload-dropdown-btn"
                  id="import-dataset"
                  >数据集</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item
                :command="3"
                class="upload-dropdown-item-box">
                <el-button
                  type="text"
                  size="small"
                  class="upload-dropdown-btn"
                  id="import-scene"
                  >场景</el-button
                > </el-dropdown-item
              ><el-dropdown-item
                :command="1"
                class="upload-dropdown-item-box">
                <el-button
                  type="text"
                  size="small"
                  class="upload-dropdown-btn"
                  id="import-project"
                  >项目信息</el-button
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-button
          class="normal-btn"
          v-if="isChecked('Data.Migration.Import.BatchDelete')"
          size="small"
          @click="batchDelete"
          >批量删除</el-button
        >
      </div>
      <div class="filter-box">
        <div class="filter-item-box">
          <div class="name searchLabel">数据类型：</div>
          <div class="common-select-box">
            <el-cascader
              v-if="showCascader"
              class="primary-select"
              size="small"
              popper-class="common-cascader-box"
              :append-to-body="false"
              :options="dataTypeOptions"
              v-model="dataType"
              @change="handleCascaderChange"
              @visible-change="visibleChange" />
          </div>
        </div>
        <div class="filter-item-box">
          <div class="name searchLabel">导入状态：</div>
          <div class="common-select-box">
            <el-select
              class="primary-select"
              size="small"
              :popper-append-to-body="false"
              v-model="importStatus"
              @change="handleStatusChange">
              <el-option
                value="all"
                label="所有"></el-option>
              <el-option
                :value="2"
                label="排队中"></el-option>
              <el-option
                :value="0"
                label="导入中"></el-option>
              <el-option
                :value="1"
                label="导入成功"></el-option>
              <el-option
                :value="-1"
                label="导入失败"></el-option>
            </el-select>
          </div>
        </div>
        <div class="common-input-box">
          <el-input
            class="input-primary"
            size="small"
            v-model="name"
            placeholder="请输入名称搜索"
            clearable
            @clear="search"
            @keyup.enter.native="search">
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="search" />
          </el-input>
        </div>
      </div>
    </div>
    <div class="import-data-box">
      <div v-if="loading">
        <Spin
          :pointNum="8"
          :translateX="25"
          background="var(--base-primary-bgColor)" />
      </div>
      <div
        class="common-table-box"
        v-if="dataList.length && !loading">
        <el-table
          height="100%"
          class="publish-table"
          highlight-selection-row
          :header-row-class-name="customHeader"
          ref="modelTable"
          row-key="id"
          :data="dataList"
          @select="selectChange"
          @select-all="selectChange">
          <el-table-column
            type="selection"
            width="60"
            :reserve-selection="true" /><el-table-column
            label="序号"
            type="index"
            width="55"></el-table-column>
          <el-table-column
            label="源文件文件名称及大小"
            width="320">
            <template v-slot="{ row }">
              <div class="fileinfo-box">
                <div
                  class="file-name text-overflow"
                  :title="row.resourceName">
                  {{ row.resourceName }}
                </div>
                <div class="file-size">
                  {{
                    `${formatFileSize(row.resourceSize).fileSize}${
                      formatFileSize(row.resourceSize).unit
                    }`
                  }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="导入文件名称及大小"
            width="320">
            <template v-slot="{ row }">
              <div class="fileinfo-box">
                <div
                  class="file-name text-overflow"
                  :title="row.name">
                  {{ row.name }}
                </div>
                <div class="file-size">
                  {{
                    `${formatFileSize(row.length).fileSize}${
                      formatFileSize(row.length).unit
                    }`
                  }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="数据类型">
            <template v-slot="{ row }">
              <span>{{ getDataType(row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="资源类型">
            <template v-slot="{ row }">
              <span v-if="row.resourceType === 0">Windows</span>
              <span v-if="row.resourceType === 1">MinIO</span>
              <span v-if="row.resourceType === -1">--</span>
            </template>
          </el-table-column>
          <el-table-column label="导入方式">
            <template v-slot="{ row }">
              <span v-if="row.importWay === 0">本地导入</span>
              <span v-if="row.importWay === 1">在线导入</span>
            </template>
          </el-table-column>
          <el-table-column
            label="导入状态"
            width="130">
            <template v-slot="{ row }">
              <div
                v-if="row.status === -1"
                class="status-box">
                <div class="circle bg-color3"></div>
                <span class="color3">导入失败</span>
                <el-tooltip
                  :effect="$theme.tooltipKey()"
                  placement="top-start"
                  popper-class="common-panel-tooltip-box">
                  <div
                    slot="content"
                    class="content-box">
                    {{ row.failReason }}
                  </div>
                  <div class="icon-box">
                    <i class="el-icon-warning"></i>
                  </div>
                </el-tooltip>
              </div>
              <div
                class="common-progress-box"
                v-if="row.status === 0">
                <el-progress
                  class="progress-primary"
                  :show-text="false"
                  :percentage="row.progress" />
                <div class="custom-text">
                  <div class="text">{{ `${row.progress}%` }}</div>
                </div>
              </div>
              <div
                v-if="row.status === 1"
                class="status-box">
                <div class="circle bg-color4"></div>
                <span class="color4">导入成功</span>
              </div>
              <div
                v-if="row.status === 2"
                class="status-box">
                <div class="circle bg-color2"></div>
                <span class="color2">排队中</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="目标项目">
            <template v-slot="{ row }">
              <div
                class="text-overflow"
                :title="`${row.targetProjectName}`">
                {{ row.targetProjectName ? row.targetProjectName : '--' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作人">
            <template v-slot="{ row }">
              <span>{{ row.creatorName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="开始时间/完成时间"
            width="200">
            <template v-slot="{ row }">
              <div>{{ formatTime(row.creationTime) }}</div>
              <div v-if="row.status === 1">
                {{
                  row.finishTime
                    ? formatTime(row.finishTime)
                    : formatTime(row.creationTime)
                }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="60">
            <template v-slot="{ row }">
              <div class="common-button-box operation-cell">
                <el-button
                  v-if="isChecked('Data.Migration.Import.Delete')"
                  type="text"
                  size="small"
                  :disabled="row.importWay === 1"
                  @click="deleteImport(row)"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="common-pagination-box pagination-primary">
          <el-pagination
            popper-class="common-pagination-popper-box"
            layout="sizes, prev, pager, next, jumper"
            :page-sizes="[10, 20, 50, 100, 150, 200]"
            :page-size="pageSize"
            :current-page="currPage"
            :total="total"
            @size-change="pageSizeChange"
            @current-change="pageChange">
          </el-pagination>
        </div>
      </div>
      <div
        class="common-empty-box"
        v-if="!dataList.length && !loading">
        <bj-empty
          :image="require('@/assets/img/no-data.png')"
          class="empty-page">
          <template slot="description">
            <div class="empty-text">抱歉，没有找到相关内容</div>
          </template>
          <!-- <div class="common-button-box">
            <div
              class="common-dropdown-box"
              v-if="isChecked('Data.Migration.Import.Import')">
              <el-dropdown
                placement="bottom"
                @visible-change="handleEmptyVisibleChange"
                @command="importData">
                <el-button
                  type="primary"
                  size="small"
                  >本地导入</el-button
                >
                <el-dropdown-menu
                  slot="dropdown"
                  class="common-dropdown-menu">
                  <el-dropdown-item
                    :command="2"
                    class="upload-dropdown-item-box">
                    <el-button
                      type="text"
                      size="small"
                      class="upload-dropdown-btn"
                      id="empty-import-dataset">
                      数据集
                    </el-button>
                  </el-dropdown-item>
                  <el-dropdown-item
                    :command="3"
                    class="upload-dropdown-item-box">
                    <el-button
                      type="text"
                      size="small"
                      class="upload-dropdown-btn"
                      id="empty-import-scene">
                      场景
                    </el-button>
                  </el-dropdown-item>
                  <el-dropdown-item
                    :command="1"
                    class="upload-dropdown-item-box">
                    <el-button
                      type="text"
                      size="small"
                      class="upload-dropdown-btn"
                      id="empty-import-project">
                      项目信息
                    </el-button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div> -->
        </bj-empty>
      </div>
    </div>
  </div>
</template>

<script>
import Spin from '@/components/Spin.vue'

import { Store } from '@/utils/store'
import { formatTime, formatFileSize } from '@/utils/generalMethods'

import {
  getImportListService,
  deleteImport,
  batchDeleteImport,
  getProjOwnerListService
} from '@/service/interface'

export default {
  data() {
    return {
      customHeader: '',
      dataType: undefined,
      importStatus: undefined,
      name: '',
      dataTypeOptions: [
        { value: 'all', label: '所有' },
        { value: 0, label: '项目信息' },
        {
          value: 'dataSet',
          label: '数据集',
          children: [
            { value: 'allDataSet', label: '全部' },
            { value: 'Model', label: '模型' },
            { value: 'ModelGroup', label: '模型组' },
            { value: 'Rs', label: '遥感影像' },
            { value: 'Wmts', label: 'WMTS' },
            { value: 'Osgb', label: '倾斜摄影' },
            { value: 'Panorama', label: '360全景图' },
            { value: 'PointCloud', label: '点云' },
            { value: 'Cad', label: '二维图纸' },
            { value: 'Vector', label: '矢量数据' }
          ]
        },
        { value: 1, label: '场景' }
      ],

      loading: false,
      dataList: [],
      selectDatas: [],
      total: 0,
      currPage: 1,
      pageSize: 10,
      showCascader: true
    }
  },
  props: {
    openUploadListDialog: Function,
    updateImportType: Function,
    importUploader: Object,
    openImportDialog: Function
  },
  components: {
    Spin
  },
  mounted() {
    this.initImportList()
    this.importUploader.on('importFilesQueued', this.onFilesQueued)
    this.importUploader.on('refreshImportList', this.refreshImportList)
    this.$eventManage.on('importFiles', this.importFiles)
    this.$eventManage.on('cancelImport', this.onCancelImport)
    this.$nextTick(() => {
      setTimeout(() => {
        const currentBody = this.$refs.modelTable?.bodyWrapper
        currentBody &&
          currentBody.addEventListener('scroll', ev => {
            const scrollTop = ev.target.scrollTop
            this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
          })
      }, 500)
    })
  },
  beforeDestroy() {
    this.importUploader.off('importFilesQueued', this.onFilesQueued)
    this.importUploader.off('refreshImportList', this.refreshImportList)
    this.$eventManage.off('importFiles', this.importFiles)
    this.$eventManage.off('cancelImport', this.onCancelImport)
  },
  methods: {
    handleVisibleChange(visible) {
      if (visible) {
        this.$nextTick(() => {
          let importProjectDom = document.getElementById('import-project')
          let child1 = importProjectDom.children[0]
          if (!child1.className.includes('webuploader-pick')) {
            this.importUploader.uploader.addButton({
              id: '#import-project'
            })
          }

          let importDataSetDom = document.getElementById('import-dataset')
          let child2 = importDataSetDom.children[0]
          if (!child2.className.includes('webuploader-pick')) {
            this.importUploader.uploader.addButton({
              id: '#import-dataset'
            })
          }

          let importSceneDom = document.getElementById('import-scene')
          let child3 = importSceneDom.children[0]
          if (!child3.className.includes('webuploader-pick')) {
            this.importUploader.uploader.addButton({
              id: '#import-scene'
            })
          }
        })
      }
    },
    handleEmptyVisibleChange(visible) {
      if (visible) {
        this.$nextTick(() => {
          let importProjectDom = document.getElementById('empty-import-project')
          let child1 = importProjectDom.children[0]
          if (!child1.className.includes('webuploader-pick')) {
            this.importUploader.uploader.addButton({
              id: '#empty-import-project'
            })
          }

          let importDataSetDom = document.getElementById('empty-import-dataset')
          let child2 = importDataSetDom.children[0]
          if (!child2.className.includes('webuploader-pick')) {
            this.importUploader.uploader.addButton({
              id: '#empty-import-dataset'
            })
          }

          let importSceneDom = document.getElementById('empty-import-scene')
          let child3 = importSceneDom.children[0]
          if (!child3.className.includes('webuploader-pick')) {
            this.importUploader.uploader.addButton({
              id: '#empty-import-scene'
            })
          }
        })
      }
    },
    initImportList() {
      this.loading = true
      this.queryImportList().then(response => {
        let { dataList, total } = response
        this.dataList = dataList
        this.total = total

        this.timer && clearInterval(this.timer)
        let importingStatus = [0, 2]
        let importingData = dataList.filter(el =>
          importingStatus.includes(el.status)
        )
        if (importingData.length) {
          this.timer = setInterval(this.refreshImportList, 5 * 1000)
        }

        this.loading = false
      })
    },
    openUploadList() {
      this.openUploadListDialog()
    },
    importData(command) {
      this.importUploader.setStatus('waiting')
      switch (command) {
        case 1:
          this.updateImportType(0)
          this.importUploader.setImportType(0)
          break
        case 2:
          this.updateImportType(2)
          this.importUploader.setImportType(2)
          break
        case 3:
          this.updateImportType(1)
          this.importUploader.setImportType(1)
          break
        default:
          break
      }
    },
    onFilesQueued(eventInfo) {
      if (this.importUploader.importType === 0) {
        getProjOwnerListService({}).then(response => {
          if (response.isSuccess) {
            let projOwnerList = response.data
            if (projOwnerList.length === 1) {
              let importParams = {
                ownerId: projOwnerList[0].userId
              }
              this.importFiles({ importParams })
            } else {
              this.openImportDialog()
            }
          } else {
            this.$message.error(response.errMsg)
          }
        })
      } else {
        let { importFilesInfo } = eventInfo
        this.openImportDialog(importFilesInfo)
      }
    },
    importFiles(params) {
      this.dataType = undefined
      this.importStatus = undefined
      this.name = ''
      this.importUploader.fire('importFiles', params)
    },
    onCancelImport() {
      this.importUploader.fire('cancelImport', null)
    },
    updateImportList() {
      this.initImportList()
    },
    visibleChange(flag) {
      if (flag) return
      this.showCascader = false
      this.$nextTick(() => {
        this.showCascader = true
      })
    },
    handleCascaderChange(dataType) {
      if (dataType.length === 1) {
        let value = dataType[0]
        this.dataType = value
      }
      if (dataType.length === 2) {
        let value = dataType[1]
        this.dataType = value
      }
      this.currPage = 1
      this.initImportList()
    },
    handleStatusChange() {
      this.currPage = 1
      this.initImportList()
    },
    search() {
      this.currPage = 1
      this.initImportList()
    },
    deleteImport(importInfo) {
      this.$confirm('确定删除选中的数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let id = importInfo.id
          deleteImport(id).then(response => {
            if (response.isSuccess) {
              this.$message.success('删除成功')
              this.currPage = 1
              this.initImportList()
            } else {
              this.$message.error(response.errMsg)
            }
          })
        })
        .catch(() => {
          // this.$message.info('取消删除')
        })
    },
    batchDelete() {
      if (!this.selectDatas.length) {
        this.$message.warning('请先勾选文件')
        return
      }

      let inValidDatas = this.selectDatas.filter(
        el => el.status === 0 || el.importWay === 1
      )
      if (inValidDatas.length === this.selectDatas.length) {
        let errMsg = '在线导入和正在导入中的数据，不能删除！'
        this.$message.error(errMsg)
        return
      }

      let warningMsg = ''
      if (inValidDatas.length) {
        warningMsg = '在线导入和正在导入的数据不支持删除，是否跳过继续删除?'
      } else {
        warningMsg = '确定删除选中的数据?'
      }
      let validDatas = this.selectDatas.filter(
        el => el.status !== 0 && el.importWay === 0
      )
      let ids = validDatas.map(el => el.id)
      this.$confirm(warningMsg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          batchDeleteImport(ids).then(response => {
            if (response.isSuccess) {
              this.$message.success('删除成功')
              this.currPage = 1
              this.initImportList()
            } else {
              this.$message.error(response.errMsg)
            }
          })
        })
        .catch(() => {
          // this.$message.info('取消删除')
        })
    },
    selectChange(selection) {
      this.selectDatas = selection
    },
    pageSizeChange(pageSize) {
      this.currPage = 1
      this.pageSize = pageSize
      this.initImportList()
    },
    pageChange(currPage) {
      this.currPage = currPage
      this.initImportList()
    },
    refreshImportList() {
      this.queryImportList().then(response => {
        let { dataList, total } = response
        this.dataList = dataList
        this.total = total

        let importingStatus = [0, 2]
        let importingData = dataList.filter(el =>
          importingStatus.includes(el.status)
        )
        if (importingData.length) {
          this.timer && clearInterval(this.timer)
          this.timer = null
          this.timer = setInterval(this.refreshImportList, 5 * 1000)
        } else {
          this.timer && clearInterval(this.timer)
          this.timer = null
        }
      })
    },
    queryImportList() {
      return new Promise(resolve => {
        let params = this.getQueryParams()
        getImportListService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let dataList = data.items
            dataList.forEach(el => {
              el.progress = Number((el.progress * 100).toFixed(2))
            })
            let total = data.totalCount
            resolve({ dataList, total })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    getQueryParams() {
      let params = {
        status: this.importStatus === 'all' ? undefined : this.importStatus,
        name: this.name,
        resultCount: this.pageSize,
        skipCount: (this.currPage - 1) * this.pageSize
      }

      switch (this.dataType) {
        case 'all':
          params.importType = undefined
          break
        case 0:
        case 1:
          params.importType = this.dataType
          break
        case 'allDataSet':
          params.importType = 2
          break
        case 'Model':
          params.importType = 2
          params.scheme = 'Bim'
          params.formatType = 1
          break
        case 'ModelGroup':
          params.importType = 2
          params.scheme = 'Bim'
          params.formatType = 2
          break
        case 'Rs':
        case 'Wmts':
        case 'Osgb':
        case 'Panorama':
        case 'PointCloud':
        case 'Cad':
        case 'Vector':
          params.importType = 2
          params.scheme = this.dataType
          // params.formatType = 1;
          break
      }

      return params
    },
    getDataType(importInfo) {
      let dataTypeDes = ''
      let importType = importInfo.importType
      let scheme = importInfo.scheme
      let formatType = importInfo.formatType
      switch (importType) {
        case 0:
          dataTypeDes = '项目信息'
          break
        case 1:
          dataTypeDes = '场景'
          break
        case 2:
          if (scheme === 'Bim') {
            if (formatType === 1) {
              dataTypeDes = '模型'
            } else {
              dataTypeDes = '模型组'
            }
          } else if (scheme === 'Rs') {
            dataTypeDes = '遥感影像'
          } else if (scheme === 'Wmts') {
            dataTypeDes = 'WMTS'
          } else if (scheme === 'Osgb') {
            dataTypeDes = '倾斜摄影'
          } else if (scheme === 'Panorama') {
            dataTypeDes = '360全景图'
          } else if (scheme === 'PointCloud') {
            dataTypeDes = '点云'
          } else if (scheme === 'Cad') {
            dataTypeDes = '二维图纸'
          } else if (scheme === 'Vector') {
            dataTypeDes = '矢量数据'
          }
          break
      }
      return dataTypeDes
    },
    getExceptionMessage(files, messageTail) {
      let message = ''
      // 超过两个文件只展示前两个
      if (files.length > 2) {
        let fileNames = `${files[0]}、${files[1]}等${files.length}个文件`
        message = `${fileNames}${messageTail}`
      } else {
        message = `${files}${messageTail}`
      }
      return message
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    formatTime,
    formatFileSize
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.data-import-container {
  height: 100%;
  text-align: left;

  .header {
    display: flex;
    justify-content: space-between;
    margin: 16px 0;
    padding: 0 16px;

    p {
      height: 20px;
      line-height: 10px;
      margin: 5px 0px;
      padding: 4px 10px;
      border-left: 4px solid var(--base-primary-bgColor);
    }

    .title {
      color: var(--page-title-color);
    }

    .common-button-box {
      &.import-btn {
        :deep(.el-button) {
          padding-top: 8px;
          padding-bottom: 8px;
        }
      }
      .el-button {
        margin-right: 0px;
      }

      .btn-list {
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }
    }
  }

  .operate-area-box {
    display: flex;
    justify-content: space-between;
    padding: 0 16px;

    .common-button-box {
      display: flex;

      // .el-button {
      //   width: 90px;
      // }
    }

    .filter-box {
      display: flex;
      .filter-item-box {
        display: flex;
        margin-right: 24px;

        .name {
          color: var(--page-search-label-color);
          line-height: 32px;
        }

        // .common-select-box {
        //   width: 120px;
        // }
      }
    }
  }

  .import-data-box {
    margin-top: 16px;
    padding: 0 16px;
    height: calc(100% - 94px);

    .common-table-box {
      height: calc(100% - 65px);

      .fileinfo-box {
        display: flex;
        flex-direction: column;

        .file-name {
          width: 160px;
        }

        .file-size {
          width: 107px;
          text-align: left;
          font-size: 12px;
          color: var(--disabled-text-color);
        }
      }

      .status-box {
        display: flex;
        font-size: 12px;

        .circle {
          width: 5px;
          height: 5px;
          margin: auto 5px auto 0px;
          border-radius: 50%;
        }

        .icon-box {
          margin: 0px 5px;
          color: var(--error-status-color);
        }

        .bg-color1 {
          background: var(--table-cell-status-text-color);
        }

        .bg-color2 {
          background: var(--runing-status-color);
        }

        .bg-color3 {
          background: var(--error-status-color);
        }

        .bg-color4 {
          background: var(--success-status-color);
        }

        .color1 {
          color: var(--table-cell-status-text-color);
        }

        .color2 {
          color: var(--runing-status-color);
        }

        .color3 {
          color: var(--error-status-color);
        }

        .color4 {
          color: var(--success-status-color);
        }
      }

      .common-progress-box {
        display: flex;

        .el-progress {
          width: 40%;
        }

        .custom-text {
          width: 50px;
          line-height: 12px;
          font-size: 12px;
          text-align: center;

          .text {
            color: var(--base-primary-bgColor);
          }
        }

        &:hover {
          .custom-text {
            display: block;
          }
        }
      }
      .common-pagination-box {
        text-align: center;
      }
    }

    .common-empty-box {
      color: var(--normal-status-color);
      margin-top: 10px;
      height: calc(100% - 75px);

      .common-button-box {
        .el-button {
          width: 100px;
        }
      }
    }
  }
}
</style>
